import { createApiResource, UnpagedListHookResult, UnpagedListResource } from '../apiResourceFactory';
import { ServiceTitanAPI } from '../apiService';
import { ST } from '../apiTypes.shim';

interface ServiceTitanJobCancelReasonResource extends UnpagedListResource<ST.JobCancelReason> {
  useUnpagedListCached: () => UnpagedListHookResult<ST.JobCancelReason>;
}

export const createServiceTitanJobCancelReasonResource = (companyId: string): ServiceTitanJobCancelReasonResource => {
  const jobCancelReasonsUri = `${companyId}/job-cancel-reasons`;
  const { useUnpagedList, unpagedList, unpagedListQueryKey } = createApiResource(ServiceTitanAPI, jobCancelReasonsUri);

  return {
    useUnpagedList,
    unpagedList,
    unpagedListQueryKey,
    useUnpagedListCached: () => useUnpagedList({}, { refetchOnMount: false })
  };
};
